<template lang='pug' src='./home-mobile.pug'></template>

<script>
import About from 'components/sections/about-us/about-us'
import Contact from 'components/sections/contact/contact'
import HeroMobile from 'components/hero/hero-mobile/hero-mobile'
import Loader from 'components/loader/loader'
import Modal from 'components/modal/modal'
import NavigationMobile from 'components/navigation/nav-mobile/nav-mobile'
import OfficeModal from 'components/modal/office-modal/office-modal'
// import Payments from 'components/sections/payments/payments'
import Testimonials from 'components/sections/testimonials/testimonials'
import Treatments from 'components/sections/treatments/treatments'
import Welcome from 'components/sections/welcome/welcome'
import Why from 'components/sections/why/why'

export default {
  name: 'home-mobile',
  computed: {
    props () {
      return this.$store.state.pages.home
    },
    loading () {
      return this.$store.state.loading
    }
  },
  components: {
    About,
    Contact,
    HeroMobile,
    Loader,
    Modal,
    NavigationMobile,
    OfficeModal,
    // Payments,
    Testimonials,
    Treatments,
    Welcome,
    Why
  }
}
</script>



// WEBPACK FOOTER //
// home-mobile.vue?ef423794